// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kJB9G6cAEojjC93f {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 97px;
  min-height: calc(100vh - 97px);
  position: relative;
  padding-bottom: 108px;
}

.ed_bQN2QbLorF9Qi {
  margin-top: 108px;
  border-radius: 16px;
  max-width: 675px;
  padding: 36px;
  width: 100%;
}

.ed_bQN2QbLorF9Qi .p-card-title {
  text-align: center;
  font-size: 30px;
  font-family: Roboto;
  color: #303030;
  font-weight: bold;
  margin-bottom: 38px;
}

.ed_bQN2QbLorF9Qi .p-card-body {
  padding: 0;
}

.ed_bQN2QbLorF9Qi .p-card-content {
  padding: 0;
}

.nRp0cnW6wYHI9JGq {
  margin-bottom: 1rem;
}

.nRp0cnW6wYHI9JGq label {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 400;
}

.nRp0cnW6wYHI9JGq input {
  border-radius: 16px;
  padding: 15px 18px 18px;
  font-size: 20px;
}

.nRp0cnW6wYHI9JGq input:-webkit-autofill {
  font-size: 20px !important;
}

.nRp0cnW6wYHI9JGq input::placeholder {
  font-family: Roboto;
  color: #a4a4a4;
}

.nRp0cnW6wYHI9JGq .p-icon-field-right > .p-input-icon:last-of-type {
  right: 20px;
}

.CHhCPwmqUf4PxeK4 {
  width: 100%;
  border-radius: 16px;
  margin-top: 38px;
  font-size: 20px;
  font-weight: 500;
  background-color: #4d87be;
  padding: 18px 0 22px;
  font-family: Roboto;
}

.Ird8R6Zx0OYZDcep {
  margin-top: 0.4rem;
  display: block;
}

.NAIjnHtM5uMiJjzT {
  font-family: Roboto;
  font-size: 16px;
  color: #555;
  margin-bottom: 24px;
  text-align: center;
}

.qKepYbi5ssjS3aCa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.nUbP0blILxccBJEy {
  font-family: Roboto;
  font-size: 14px;
  color: #777;
}

.OLCvcV5mXkocv0hm {
  font-family: Roboto;
  font-size: 14px;
  color: #4d87be;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".wrapper {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  margin-top: 97px;\r\n  min-height: calc(100vh - 97px);\r\n  position: relative;\r\n  padding-bottom: 108px;\r\n}\r\n\r\n.card {\r\n  margin-top: 108px;\r\n  border-radius: 16px;\r\n  max-width: 675px;\r\n  padding: 36px;\r\n  width: 100%;\r\n}\r\n\r\n.card :global(.p-card-title) {\r\n  text-align: center;\r\n  font-size: 30px;\r\n  font-family: Roboto;\r\n  color: #303030;\r\n  font-weight: bold;\r\n  margin-bottom: 38px;\r\n}\r\n\r\n.card :global(.p-card-body) {\r\n  padding: 0;\r\n}\r\n\r\n.card :global(.p-card-content) {\r\n  padding: 0;\r\n}\r\n\r\n.fieldContainer {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.fieldContainer label {\r\n  font-family: Roboto;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.fieldContainer input {\r\n  border-radius: 16px;\r\n  padding: 15px 18px 18px;\r\n  font-size: 20px;\r\n}\r\n\r\n.fieldContainer input:-webkit-autofill {\r\n  font-size: 20px !important;\r\n}\r\n\r\n.fieldContainer input::placeholder {\r\n  font-family: Roboto;\r\n  color: #a4a4a4;\r\n}\r\n\r\n.fieldContainer :global(.p-icon-field-right > .p-input-icon:last-of-type) {\r\n  right: 20px;\r\n}\r\n\r\n.submitButton {\r\n  width: 100%;\r\n  border-radius: 16px;\r\n  margin-top: 38px;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  background-color: #4d87be;\r\n  padding: 18px 0 22px;\r\n  font-family: Roboto;\r\n}\r\n\r\n.errorMessage {\r\n  margin-top: 0.4rem;\r\n  display: block;\r\n}\r\n\r\n.otpHint {\r\n  font-family: Roboto;\r\n  font-size: 16px;\r\n  color: #555;\r\n  margin-bottom: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.otpFooter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 12px;\r\n}\r\n\r\n.otpTimer {\r\n  font-family: Roboto;\r\n  font-size: 14px;\r\n  color: #777;\r\n}\r\n\r\n.otpResend {\r\n  font-family: Roboto;\r\n  font-size: 14px;\r\n  color: #4d87be;\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `kJB9G6cAEojjC93f`;
export var card = `ed_bQN2QbLorF9Qi`;
export var fieldContainer = `nRp0cnW6wYHI9JGq`;
export var submitButton = `CHhCPwmqUf4PxeK4`;
export var errorMessage = `Ird8R6Zx0OYZDcep`;
export var otpHint = `NAIjnHtM5uMiJjzT`;
export var otpFooter = `qKepYbi5ssjS3aCa`;
export var otpTimer = `nUbP0blILxccBJEy`;
export var otpResend = `OLCvcV5mXkocv0hm`;
export default ___CSS_LOADER_EXPORT___;
